var map = {
	"./Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg": 71277,
	"./Huawei_AppGallery_Badge_Color_Type=Black_Language=EN.svg": 83289,
	"./default_sport.svg": 98486,
	"./down-arrow.svg": 99778,
	"./leagues/Bundesliga.svg": 30171,
	"./leagues/LaLiga.svg": 94991,
	"./leagues/Ligue 1.svg": 63646,
	"./leagues/Premier League.svg": 48816,
	"./leagues/Serie A.svg": 2304,
	"./leagues/UEFA Champions League.svg": 29781,
	"./mobile/Aviator.svg": 95771,
	"./mobile/Casino.svg": 80786,
	"./mobile/Home.svg": 39918,
	"./mobile/Jackpot.svg": 87619,
	"./mobile/League.svg": 4484,
	"./mobile/Live.svg": 43329,
	"./mobile/MyBets.svg": 18565,
	"./mobile/Profile.svg": 50302,
	"./mobile/crash.svg": 47916,
	"./mobile/facebook.svg": 3591,
	"./mobile/jet.svg": 46920,
	"./mobile/twitter.svg": 36240,
	"./mobile/whatsapp.svg": 11137,
	"./padlock.svg": 92444,
	"./under-maintenance.svg": 85358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19832;